var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-modal',{attrs:{"title":"权限信息","visible":_vm.lookBool,"footer":null},on:{"cancel":_vm.handleCancel}},[_c('div',{staticClass:"tree"},[_c('a-tree',{attrs:{"showLine":"","default-checked-keys":_vm.treeNode,"checkedKeys":_vm.treeNode,"tree-data":_vm.treeData,"checkable":"","defaultExpandAll":"","checkStrictly":""}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }